import React from 'react';
import { Calendar, User, ExternalLink, Trophy, Tag } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const ProjectCard = ({ project, categoryName }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).getFullYear().toString();
  };

  return (
    <Card className="group hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border-l-4 border-l-emerald-500 relative" data-testid={`project-card-${project.id}`}>
      <CardHeader className="pb-3">
        <Badge variant="secondary" className="mb-2 w-fit bg-emerald-50 text-emerald-700 border-emerald-200">
          {categoryName}
        </Badge>
        <CardTitle className="text-lg font-semibold text-gray-900 line-clamp-2 leading-tight">
          {project.title}
        </CardTitle>
        <CardDescription className="text-gray-600 line-clamp-3 leading-relaxed">
          {project.description}
        </CardDescription>
      </CardHeader>
      
      <CardContent className="space-y-4">
        <div className="flex items-center space-x-4 text-sm text-gray-600">
          <div className="flex items-center space-x-1">
            <User className="w-4 h-4" />
            <span className="font-medium">{project.author}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Calendar className="w-4 h-4" />
            <span>{formatDate(project.date)}</span>
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
          <div className="flex items-start space-x-2">
            <Trophy className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-amber-800 mb-1">Resultados:</p>
              <p className="text-sm text-amber-700 leading-relaxed">{project.results}</p>
            </div>
          </div>
        </div>

        {project.keywords && project.keywords.length > 0 && (
          <div className="space-y-2">
            <div className="flex items-center space-x-1">
              <Tag className="w-3 h-3 text-gray-500" />
              <span className="text-xs font-medium text-gray-700">Palabras clave:</span>
            </div>
            <div className="flex flex-wrap gap-1">
              {project.keywords.slice(0, 6).map((keyword, index) => (
                <Badge 
                  key={index} 
                  variant="outline" 
                  className="text-xs px-2 py-0.5 bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
                >
                  {keyword}
                </Badge>
              ))}
              {project.keywords.length > 6 && (
                <Badge 
                  variant="outline" 
                  className="text-xs px-2 py-0.5 bg-gray-50 text-gray-500 border-gray-200"
                >
                  +{project.keywords.length - 6} más
                </Badge>
              )}
            </div>
          </div>
        )}

        <Button 
          asChild 
          className="w-full bg-emerald-600 hover:bg-emerald-700 transition-colors duration-200"
          data-testid="view-project-btn"
        >
          <a 
            href={project.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center space-x-2"
          >
            <span>Ver Proyecto Completo</span>
            <ExternalLink className="w-4 h-4" />
          </a>
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProjectCard;
